import { useEffect } from "react";
import { defineMessages } from "react-intl";

import { useFormatMessage } from "../Intl/Context";
import Button from "../Buttons/Button";
import Icon from "../Utils/Icon";
import { useBottomSheetPanelContext } from "../Panels/BottomSheetPanel";

// Completion screen shown after the user has reviewed all suggestions. Offers two
// choices: see more suggestions (loading a new batch) or close the funnel and resume
// writing.
//
const FunnelCompletion = ({
  onResume,
  onSeeMore,
  isSeekingMore,
  hasNoMoreSuggestions
}) => {
  const t = useFormatMessage();
  const title = t(intlMessages.completionTitle);
  const text = t(intlMessages.completionText);
  const resumeLabel = t(intlMessages.resumeContribution);
  const seeMoreLabel = t(intlMessages.seeMoreSimilarContributions);
  const noMoreSuggestionsText = t(intlMessages.noMoreSuggestions);

  const { setNavFooterContent } = useBottomSheetPanelContext();

  useEffect(() => {
    setNavFooterContent(
      <div className="bottom-sheet-panel-actions">
        {hasNoMoreSuggestions ? (
          <p className="text-muted text-sm bottom-sheet-panel-action">
            {noMoreSuggestionsText}
          </p>
        ) : (
          <Button
            type="button"
            className="btn btn-primary-inverse btn-block-md bottom-sheet-panel-action"
            onClick={onSeeMore}
            label={seeMoreLabel}
            iconClassName="icon-plus margin-left-xs"
            iconPosition="before"
            data-loading={isSeekingMore}
            data-see-more-suggestions-button
          />
        )}

        <Button
          type="button"
          className="btn btn-primary btn-block-md bottom-sheet-panel-action"
          onClick={onResume}
          label={resumeLabel}
          iconClassName="icon-close margin-right-xs"
          iconPosition="after"
          data-close-funnel-button
        />
      </div>
    );

    return () => setNavFooterContent(null);
  }, [
    hasNoMoreSuggestions,
    isSeekingMore,
    noMoreSuggestionsText,
    onResume,
    onSeeMore,
    resumeLabel,
    seeMoreLabel,
    setNavFooterContent
  ]);

  return (
    <>
      <div className="box text-center padding-md">
        <div className="bg-success text-white m-auto d-inline-flex padding-xs rounded-circle margin-bottom-xs">
          <Icon className="fa fa-check" />
        </div>

        <h3 className="text-lg margin-bottom-xs">{title}</h3>

        <p className="text-muted text-sm margin-bottom-md">{text}</p>
      </div>
    </>
  );
};

export default FunnelCompletion;

const intlMessages = defineMessages({
  completionTitle: {
    id: "contributionsReviewFunnel.completionTitle",
    defaultMessage: "Fin des suggestions"
  },
  completionText: {
    id: "contributionsReviewFunnel.completionText",
    defaultMessage: `Vous avez passé en revue toutes les contributions en rapport.
      Vous pouvez désormais décider de reprendre la rédaction de votre contribution ou de
      chercher de nouvelles suggestions.`
  },
  resumeContribution: {
    id: "contributionsReviewFunnel.resumeContribution",
    defaultMessage: "Fermer"
  },
  seeMoreSimilarContributions: {
    id: "contributionsReviewFunnel.seeMoreSimilarContributions",
    defaultMessage: "de suggestions"
  },
  noMoreSuggestions: {
    id: "contributionsReviewFunnel.noMoreSuggestions",
    defaultMessage: "Aucune autre suggestion similaire n'a été trouvée."
  }
});
